import Doctor from 'models/Doctor';
import { PermissionText } from 'models/Permission';

// is_admin and is_manager permissions are a patch, this service should eventually be removed and replaced with
// individual permission for every location using it (use currentClinician.hasPermission(X)
export class PermissionService {
  static hasAdminOrManagerPermissions(doctor: Doctor) {
    return doctor.role.permissions?.some(
      (permission) =>
        permission.name === PermissionText.IsManager || permission.name === PermissionText.IsAdmin
    );
  }
  static hasAdminPermission(doctor: Doctor) {
    return doctor.role.permissions?.some(
      (permission) => permission.name === PermissionText.IsAdmin
    );
  }
}
